import React, { useContext } from 'react';
import { Redirect, Route } from 'react-router-dom';

import { UserContext } from '../context/UserContext';

const InscricaoAdminRoute = props => {
  const { isInscricaoAdmin } = useContext(UserContext);

  if (isInscricaoAdmin) {
    return <Route {...props} />;
  } else if (!isInscricaoAdmin) {
    return <Redirect to='/login' />;
  } else {
    return null;
  }
};

export default InscricaoAdminRoute;
